const ASSETS = '/proyectos/el-molino-del-churqui';

// Sector colors follow the developer's sector plan.
const SECTORS = [
  { id: 'alto', color: '#2f6b3f', ink: '#ffffff' },
  { id: 'central', color: '#7fb04a', ink: '#14200b' },
  { id: 'lateral', color: '#e2cf3a', ink: '#2a2406' },
  { id: 'comercial', color: '#4a9fd8', ink: '#ffffff' },
];

// x/y are percentages over plano.webp, matching the block markers of the developer's official plan.
const BLOCKS = [
  { id: 'A', sector: 'alto', min: 1055, max: 3333, x: 24.3, y: 15.8 },
  { id: 'B', sector: 'alto', min: 1840, max: 3973, x: 33.3, y: 26.1 },
  { id: 'C', sector: 'alto', min: 1498, max: 3022, x: 42.2, y: 35.5 },
  { id: 'D', sector: 'alto', min: 1006, max: 2616, x: 51.6, y: 45.4 },
  { id: 'E', sector: 'central', min: 1833, max: 3993, x: 64.1, y: 57.9 },
  { id: 'F', sector: 'central', min: 1500, max: 1533, x: 76.6, y: 73.7 },
  { id: 'I', sector: 'central', min: 1297, max: 3012, x: 60.6, y: 68.1 },
  { id: 'J', sector: 'lateral', min: 808, max: 1020, x: 48.3, y: 69.6 },
  { id: 'K', sector: 'lateral', min: 915, max: 3444, x: 35.5, y: 61.9 },
  { id: 'G', sector: 'comercial', min: 842, max: 1515, x: 85.3, y: 82.4 },
  { id: 'H', sector: 'comercial', min: 1208, max: 1492, x: 72.9, y: 85.4 },
];

export const MOLINO = {
  name: 'El Molino del Churqui',
  path: '/el-molino-del-churqui',
  location: 'Tafí del Valle, Tucumán',
  address: 'Calle Facundo Quiroga, La Banda, Tafí del Valle',
  route: 'Ruta 307',
  coords: { Latitud: -26.8484583, Longitud: -65.7219667 },
  mapsQuery: 'El Molino del Churqui desarrollo Inmobiliario',
  mapsUrl: 'https://www.google.com/maps/place/El+Molino+del+Churqui+desarrollo+Inmobiliario/@-26.8484583,-65.7219667,16z/data=!4m6!3m5!1s0x9422188259fe8335:0x85be6c9962f76d83!8m2!3d-26.8484583!4d-65.7219667',
  instagram: 'https://www.instagram.com/elmolinodelchurqui/',
  images: {
    hero: `${ASSETS}/panorama.webp`,
    heroSmall: `${ASSETS}/panorama-800.webp`,
    plan: `${ASSETS}/plano.webp`,
    og: `${ASSETS}/og.jpg`,
    logo: `${ASSETS}/logo.png`,
    logoLight: `${ASSETS}/logo-blanco.png`,
  },
  // Add new photos here (files in frontend/public/proyectos/el-molino-del-churqui).
  gallery: [
    `${ASSETS}/panorama.webp`,
    `${ASSETS}/plano.webp`,
  ],
  videos: [
    { id: 'project', src: `${ASSETS}/video-proyecto.mp4`, poster: `${ASSETS}/video-proyecto.webp`, width: 720, height: 1280 },
    { id: 'commercial', src: `${ASSETS}/video-centro-comercial.mp4`, poster: `${ASSETS}/video-centro-comercial.webp`, width: 720, height: 960 },
  ],
  sectors: SECTORS,
  blocks: BLOCKS,
  minArea: Math.min(...BLOCKS.map((block) => block.min)),
  maxArea: Math.max(...BLOCKS.map((block) => block.max)),
};

export function getSector(id) {
  return SECTORS.find((sector) => sector.id === id);
}
